import { isoOf } from './calendar';

export const COL = {
  month: 'FF9999FF', // bande des mois (violet)
  week: 'FFD9D9D9', // ligne des semaines / libellés (gris)
  weekend: 'FFF2F2F2', // colonnes week-end (gris très clair)
  ferie: 'FFE2EFDA', // colonnes fériées (vert doux)
  totalRow: 'FFEDEBFF', // ligne Total
};
export const fill = (argb) => ({ type: 'pattern', pattern: 'solid', fgColor: { argb } });
const thin = { style: 'thin', color: { argb: 'FFD9D9D9' } };
export const allBorders = { top: thin, left: thin, bottom: thin, right: thin };
export const center = () => ({ horizontal: 'center' });

export const ROW = { TITLE: 1, DOW: 2, DAY: 3, TOTAL: 4, FERIE: 5, WEEK: 6, FIRST_CAT: 7 };

export function round(n) {
  return Math.round(n * 10) / 10;
}

// Géométrie des colonnes : A(label) B(total) puis [gouttière + jours] par mois.
export function buildColumns(year) {
  let col = 3;
  const months = [];
  const dateCol = new Map();
  for (let m = 0; m < 12; m++) {
    const gutter = col++;
    const dim = new Date(year, m + 1, 0).getDate();
    const firstDay = col;
    for (let d = 1; d <= dim; d++) {
      dateCol.set(isoOf(year, m, d), col);
      col++;
    }
    months.push({ m, gutter, dim, firstDay, lastDay: col - 1 });
  }
  return { months, dateCol, lastCol: col - 1 };
}

// Appelle fn(iso, date, colonne) pour chaque jour d'un mois.
export function forEachDay(year, mo, dateCol, fn) {
  for (let d = 1; d <= mo.dim; d++) {
    const iso = isoOf(year, mo.m, d);
    fn(iso, new Date(year, mo.m, d), dateCol.get(iso), d);
  }
}
